export default __webpack_public_path__ + "static/media/sidekick.d5f36721.svg";